import { useState } from "react";

import ThreatDetailsSidebar from "./ThreatDetailsSidebar";
import ThreatDetailsContent from "./ThreatDetailsContent";

const ThreatDetails = ({ active, threatDetails }) => {
  const [selectedThreatDetail, setSelectedThreatDetail] = useState(null);

  return (
    <div className="thunter-threat-details border" style={{ marginBottom: "1rem" }}>
      <ThreatDetailsSidebar
        threatDetailsBySeverity={threatDetails[active.toLowerCase()]}
        selectedThreatDetail={selectedThreatDetail}
        setSelectedThreatDetail={setSelectedThreatDetail}
      />
      <ThreatDetailsContent severity={active} selectedThreatDetail={selectedThreatDetail} />
    </div>
  );
};

export default ThreatDetails;
